import { useAbac } from "react-abac";
import { useSelector } from "react-redux";
import authSelectors from "~/store/auth/selectors";
const useAbacExt = () => {
  const {
    userHasPermissions
  } = useAbac();
  const user = useSelector(authSelectors.getUser);
  const userHasOneOf = function (permissions) {
    let authorId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "noop";
    return permissions.some(permission => {
      if (permission.includes(".own") && authorId !== "noop") {
        return user ? userHasPermissions(permission) && (user.id === authorId || user.email === authorId) : false;
      }
      return userHasPermissions(permission);
    });
  };
  return {
    userHas: userHasPermissions,
    userHasOneOf
  };
};
export default useAbacExt;